import { getStorage } from "../storage";
import api from "../api";

const API_URL = process.env.REACT_APP_BBMS_BASE_API;

// Prompts the socket may have missed. An account that was logged out when the
// sweep ran never saw the event, so the client asks for anything outstanding
// every time it loads.
export const fetchBookingPrompts = async () => {
  try {
    const user = await getStorage();

    if (!user?.token) return [];

    const queryRes = await api({
      method: "GET",
      url: `${API_URL}/bloodRequest/booking-prompts`,
      headers: { Authorization: `Bearer ${user.token}` },
    });

    const data = queryRes?.data?.data || queryRes?.data || [];

    return Array.isArray(data) ? data : [];
  } catch (error) {
    // A failure here must never block the app: the prompt is important but a
    // broken fetch should not stop the rest of the dashboard loading.
    return [];
  }
};

export const answerBookingPrompt = async ({ id, answer, reason }) => {
  const user = await getStorage();

  const queryRes = await api({
    method: "POST",
    url: `${API_URL}/bloodRequest/booking-answer`,
    data: { id, answer, reason },
    headers: { Authorization: `Bearer ${user.token}` },
  });

  return queryRes?.data?.data || queryRes?.data || {};
};

// Marks one prompt read for this account only, so a reschedule notice does
// not reappear on the next load once it has been acknowledged.
export const dismissBookingPrompt = async (id) => {
  try {
    const user = await getStorage();

    await api({
      method: "POST",
      url: `${API_URL}/bloodRequest/booking-dismiss`,
      data: { id },
      headers: { Authorization: `Bearer ${user.token}` },
    });
  } catch (error) {
    /* dismissing is a convenience; a failure must not trap the modal */
  }
};

export const rescheduleBooking = async ({ id, bookingDate }) => {
  const user = await getStorage();

  const queryRes = await api({
    method: "POST",
    url: `${API_URL}/bloodRequest/booking-reschedule`,
    data: { id, bookingDate },
    headers: { Authorization: `Bearer ${user.token}` },
  });

  return queryRes?.data?.data || queryRes?.data || {};
};
